module.exports = __webpack_public_path__ + "img/dzCAgqap.33e69efb.svg";